import App from "../App";
import { Tween, TweenVars } from "../Tween";

export default class BangUp {

    public currentBangup: {val: number, endVal: number};
    private updateFunction: (params?: any) => void;
    private onCompleteFunction: () => void;

    public startBangup(startVal: number, endVal: number, duration, options: TweenVars, onUpdateFunction: (param: any) => void, onCompleteFunction?: () => any) {
        if (!options) {
            options = {};
        }
        this.clearBangup();
        this.currentBangup = {val: startVal, endVal};
        this.updateFunction = onUpdateFunction;
        this.onCompleteFunction = onCompleteFunction;
        options.onUpdate = this.updateFunction = onUpdateFunction;
        options.val = endVal;
        options.onUpdate = () => {
            if (this.currentBangup) {
                onUpdateFunction(this.currentBangup.val)
            }
        };
        
        options.callbackScope = this;
        options.onComplete = () => {this.clearBangup()};
        Tween.to(this.currentBangup, duration, options);
        //App.timeline.add(Tween.to(this.currentBangup, duration, options), App.timeline.time);
    }

    public clearBangup() {
        if (this.currentBangup) {
            if (this.updateFunction) {
                this.updateFunction(this.currentBangup.endVal);
            }

            Tween.killTweensOf(this.currentBangup);
            this.currentBangup = null;
            this.updateFunction = null;
            if (this.onCompleteFunction) {
                this.onCompleteFunction();
            }
            this.onCompleteFunction = null;
        }
    }
}